// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"c412b77f","57":"56c86fec","84":"524b0cb3","92":"e08bc55b","111":"a46968b2","114":"725aea3e","157":"b04de8e4","285":"b21aa414","348":"2d2d7475","370":"463575c9","386":"18e599ef","453":"04727aa3","468":"53a8be3a","643":"739ecdab","708":"fd1ea312","893":"029c4a88"}[chunkId] + ".chunk.js";
};